import { AddPaypointButton } from "Components/Paypoints/AddPaypointButton";
import { PaypointWidget } from "Components/Paypoints/PaypointWidget";
import type { PayPointBaseDto } from "Infrastructure/Api/Api";
import { Stack, Typography } from "@mui/material";

type Props = {
  title: string;
  paypoints: PayPointBaseDto[];
  limit: number | null;
  onPaypointClick: (paypoint: PayPointBaseDto) => void;
  onAddPaypoint?: () => void;
};

export const PaypointsGroup = ({
  title,
  paypoints,
  limit,
  onPaypointClick,
  onAddPaypoint,
}: Props) => (
  <Stack gap={1}>
    <Typography variant="h6">
      {title}
      {limit !== null
        ? ` (${paypoints.length}/${limit})`
        : paypoints.length > 0 && ` (${paypoints.length})`}
    </Typography>
    <Stack gap={2}>
      {paypoints.map((paypoint) => (
        <PaypointWidget
          key={paypoint.publicID}
          paypoint={paypoint}
          onClick={() => onPaypointClick(paypoint)}
        />
      ))}
      {onAddPaypoint && <AddPaypointButton onClick={onAddPaypoint} />}
    </Stack>
  </Stack>
);
